import { render, staticRenderFns } from "./TestAttachment.vue?vue&type=template&id=3303dfc5&"
import script from "./TestAttachment.vue?vue&type=script&lang=js&"
export * from "./TestAttachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports